// Get the button
const backToTop = document.getElementById("backToTop");

// Show button after scrolling down 300px
window.onscroll = function () {
  if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
    backToTop.style.display = "block";
  } else {
    backToTop.style.display = "none";
  }
};

// Scroll to top on click
backToTop.onclick = function () {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
